import React, { useState, useEffect } from 'react';
import { COLORS } from '../../utils/constants';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import MobileBottomNav from './MobileBottomNav';
import MobileHeader from './MobileHeader';


const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Load collapsed state from localStorage
  useEffect(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    if (saved !== null) {
      setSidebarCollapsed(JSON.parse(saved));
    }
  }, []);

  const handleToggleSidebarCollapse = () => {
    const newState = !sidebarCollapsed;
    setSidebarCollapsed(newState);
    localStorage.setItem('sidebarCollapsed', JSON.stringify(newState));
  };

  // Trading page has its own layout on mobile
  const isTradingPage = location.pathname === '/trading';
  const isHomePage = location.pathname === '/';
  const hideMobileNav = isTradingPage;
  const hideMobileHeader = isTradingPage || isHomePage; // Home has premium header

  // Mobile Layout
  if (isMobile) {
    return (
      <div style={{ 
        backgroundColor: COLORS.background, 
        minHeight: '100vh',
        color: COLORS.text,
        paddingBottom: hideMobileNav ? 0 : '80px',
      }}>
        {/* Mobile Header - hide on trading page and home page (they have their own) */}
        {!hideMobileHeader && <MobileHeader />}
        
        <main style={{ 
          padding: (isTradingPage || isHomePage) ? 0 : '0 16px 16px',
          maxWidth: '100%',
          overflowX: 'hidden',
        }}>
          <Outlet />
        </main>

        {/* Mobile Bottom Navigation */}
        <MobileBottomNav hidden={hideMobileNav} />
      </div>
    );
  }

  // Desktop Layout
  return (
    <div style={{ 
      backgroundColor: COLORS.background, 
      minHeight: '100vh',
      color: COLORS.text 
    }}>
      <Header 
        onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} 
        sidebarCollapsed={sidebarCollapsed}
        onToggleSidebarCollapse={handleToggleSidebarCollapse}
      />
      <div style={{ display: 'flex' }}>
        <Sidebar 
          isOpen={sidebarOpen} 
          onClose={() => setSidebarOpen(false)} 
          collapsed={sidebarCollapsed}
        />
        <main style={{ 
          flex: 1, 
          padding: isTradingPage ? '0' : '24px',
          maxWidth: '100%',
          overflowX: 'hidden',
          marginLeft: sidebarCollapsed ? '72px' : '240px',
          transition: 'margin-left 0.3s ease',
        }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
